var _defs, _circle, _rect, _rect2, _g, _g2, _rect3, _rect4, _circle2, _circle3, _circle4, _rect5, _rect6, _rect7, _g3, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g4, _g5, _path, _ellipse, _path2, _path3, _g6, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path4, _path5, _g7, _circle5, _rect33, _path6, _g8, _rect34, _circle6, _circle7, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 520",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#111827",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    fill: "#FDE801"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 262,
    r: 225,
    fill: "#FEF9C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 200,
    width: 110,
    height: 110,
    fill: "url(#dots)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 210,
    width: 74,
    height: 74,
    fill: "url(#dots)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#111827",
    strokeWidth: 2,
    strokeDasharray: "5 7",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 102 C112 150 150 170 200 176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 172 C512 200 500 210 480 214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 322 C130 300 140 290 160 286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 340 C516 318 506 308 486 304"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 112,
    width: 400,
    height: 290,
    rx: 18,
    fill: "#111827"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 112,
    width: 400,
    height: 44,
    rx: 18,
    fill: "#1F2937"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 138,
    width: 400,
    height: 18,
    fill: "#1F2937"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 134,
    r: 6,
    fill: "#FDE801"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 134,
    r: 6,
    fill: "#9CA3AF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 134,
    r: 6,
    fill: "#4B5563"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 124,
    width: 96,
    height: 32,
    rx: 8,
    fill: "#111827"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 136,
    width: 68,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 136,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#4B5563"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#374151"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 182,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 208,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 234,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 260,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 286,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 312,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 338,
    width: 10,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 364,
    width: 10,
    height: 8,
    rx: 4
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 182,
    width: 52,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 182,
    width: 96,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 182,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 208,
    width: 44,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 208,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 234,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 234,
    width: 76,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 234,
    width: 104,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 260,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 260,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 286,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 286,
    width: 132,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 312,
    width: 36,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 312,
    width: 92,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 338,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 338,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 338,
    width: 12,
    height: 16,
    rx: 2,
    fill: "#FDE801"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 364,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 132h92a26 26 0 0 0 4-51.700 38 38 0 0 0-72.600-10.300A31 31 0 0 0 104 132z",
    fill: "#111827"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150 116V88m0 0l-12 12m12-12l12 12",
    stroke: "#FDE801",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 56,
    width: 124,
    height: 120,
    rx: 16,
    fill: "#FFFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484 88v56c0 7.700 13.400 14 30 14s30-6.300 30-14V88",
    fill: "#111827"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 514,
    cy: 88,
    rx: 30,
    ry: 12,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484 107c0 7.700 13.400 14 30 14s30-6.300 30-14",
    stroke: "#FDE801",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M484 126c0 7.700 13.400 14 30 14s30-6.300 30-14",
    stroke: "#FDE801",
    strokeWidth: 4
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 322,
    width: 164,
    height: 128,
    rx: 16,
    fill: "#FFFFFF"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 342,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#111827"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 358,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 404,
    width: 18,
    height: 28,
    rx: 4,
    fill: "#E5E7EB"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 390,
    width: 18,
    height: 42,
    rx: 4,
    fill: "#111827"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 398,
    width: 18,
    height: 34,
    rx: 4,
    fill: "#E5E7EB"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 376,
    width: 18,
    height: 56,
    rx: 4,
    fill: "#FDE801"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 384,
    width: 18,
    height: 48,
    rx: 4,
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150 352l14 0 0 14",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164 352l-18 18",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 340,
    width: 168,
    height: 116,
    rx: 16,
    fill: "#111827"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 398,
    r: 20,
    fill: "#FDE801"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 384,
    width: 12,
    height: 20,
    rx: 6,
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M455 398a11 11 0 0 0 22 0M466 409v5",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FDE801",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502 390v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 378v40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 386v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 372v52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 384v28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 392v12"
  }))), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 434,
    width: 72,
    height: 6,
    rx: 3,
    fill: "#4B5563"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 70,
    r: 9,
    fill: "#111827"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 456,
    r: 7,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M590 300l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 150l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.4a0ad3c5dfee0f225757f7cca79e8e56.svg";
export { ForwardRef as ReactComponent };